<template>
  <div>
    <div class="edit-lan-modal">
      <div class="modal__container--header edit-lan-modal__header">
        <div class="text">{{ header }}</div>
        <div class="close pointer">
          <span @click="close" class="mdi mdi-close"></span>
        </div>
      </div>
      <div class="edit-lan-modal__container">
        <div class="edit-lan-modal__container--row">
          <div class="row__input">
            <label class="inp">
              {{ translate("device.config_dashboard.LAN.interface") }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca"
                @mouseover="text_assistant.interface = true"
                @mouseleave="text_assistant.interface = false"
              >
                <span
                  class="hide_text interface"
                  :class="{ active: text_assistant.interface }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <input
                type="text"
                class="text disable-input"
                v-model="new_header"
                :class="{
                  invalid:
                    $v.new_header.$dirty && !$v.new_header.required,
                }"
              />
              <small
                class="red-text-12"
                v-if="$v.new_header.$dirty && !$v.new_header.required"
                >{{ translate("device.config_dashboard.empty_input") }}</small
              >
            </label>
          </div>
          <div v-if="isMacOn" class="row__input">
            <label class="inp">
              {{ translate("device.config_dashboard.LAN.mac_address") }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px"
                @mouseover="text_assistant.mac_address = true"
                @mouseleave="text_assistant.mac_address = false"
              >
                <span
                  class="hide_text mac_address"
                  :class="{ active: text_assistant.mac_address }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <input
                type="text"
                class="text disable-input"
                v-model="data.mac"
              />
            </label>
          </div>
        </div>

        <div class="edit-lan-modal__container--row">
          <label class="switch" style="line-height: 108%">
            {{ translate("device.config_dashboard.LAN.enter_mac_address") }}
            <!-- <span
              class="mdi mdi-help-circle-outline"
              style="font-size: 18px; color: #c3c7ca; position: relative"
              @mouseover="text_assistant.enter_mac = true"
              @mouseleave="text_assistant.enter_mac = false"
            >
              <span
                class="hide_text enter_mac"
                :class="{ active: text_assistant.enter_mac }"
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </span>
            </span> -->
            <input v-model="isMacOn" type="checkbox" />
            <span class="slider round"></span>
          </label>
        </div>

        <div class="edit-lan-modal__container--row">
          <div
            class="row__input"
            style="max-width: inherit; position: relative"
          >
            <label class="inp">
              {{ translate("device.config_dashboard.LAN.ports") }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca"
                @mouseover="text_assistant.ports = true"
                @mouseleave="text_assistant.ports = false"
              >
                <span
                  class="hide_text ports"
                  :class="{ active: text_assistant.ports }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
            </label>
            <multiselect
              class="multiselect_test"
              v-model="lanPorts"
              :options="newOptionsPorts"
              track-by="name"
              :custom-label="({ name }) => `${name}`"
              :multiple="true"
              :clear-on-select="false"
              :placeholder="''"
              :selectLabel="''"
              :selectedLabel="''"
              :deselectLabel="''"
              :taggable="true"
              @tag="addTag"
              :class="{
                invalid_select: $v.lanPorts.$dirty && !$v.lanPorts.required,
              }"
            />
            <small
              class="red-text-12"
              style="font-weight: 700"
              v-if="$v.lanPorts.$dirty && !$v.lanPorts.required"
              >{{ translate("device.config_dashboard.empty_input") }}</small
            >
          </div>
        </div>

        <div class="edit-lan-modal__container--row">
          <label style="padding: 0px" class="inp">
            {{ translate("device.config_dashboard.LAN.mode") }}
            <!-- <span
              class="mdi mdi-help-circle-outline"
              style="font-size: 18px; color: #c3c7ca; position: relative"
              @mouseover="text_assistant.mode = true"
              @mouseleave="text_assistant.mode = false"
            >
              <span
                class="hide_text mode"
                :class="{ active: text_assistant.mode }"
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </span>
            </span> -->
          </label>
        </div>

        <div class="edit-lan-modal__container--row">
          <div class="row__label">
            <div class="d-inline-block">
              <input
                type="radio"
                id="lan"
                value="lan"
                name="radio-group-mode"
                v-model="radioWanLan"
              />
              <label for="lan">LAN</label>
            </div>
            <div class="d-inline-block">
              <input
                type="radio"
                id="wan"
                value="wan"
                v-model="radioWanLan"
                name="radio-group-mode"
              />
              <label for="wan">WAN</label>
            </div>
          </div>
        </div>

        <div v-if="radioWanLan == 'wan'">
          <div class="edit-lan-modal__container--row">
            <div class="row__input">
              <label>
                {{ translate("device.config_dashboard.LAN.wan_interfaces") }}
                <!-- <span
                  class="mdi mdi-help-circle-outline"
                  style="font-size: 18px; color: #c3c7ca"
                  @mouseover="text_assistant.wan_interfaces = true"
                  @mouseleave="text_assistant.wan_interfaces = false"
                >
                  <span
                    class="hide_text wan_interfaces"
                    :class="{ active: text_assistant.wan_interfaces }"
                  >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </span>
                </span> -->
              </label>
              <multiselect
                class="multiselect_test"
                v-model="data.lan_wan"
                :options="listWanTunnels"
                :multiple="true"
                :clear-on-select="false"
                :searchable="false"
                :placeholder="''"
                :selectLabel="''"
                :selectedLabel="''"
                :deselectLabel="''"
              />
            </div>
          </div>
          <div class="edit-lan-modal__container--row">
            <label style="padding: 0px" class="inp">
              {{ translate("device.config_dashboard.LAN.method_ipv") }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.method_ipv4 = true"
                @mouseleave="text_assistant.method_ipv4 = false"
              >
                <span
                  class="hide_text method_ipv4"
                  :class="{ active: text_assistant.method_ipv4 }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
            </label>
          </div>

          <div class="edit-lan-modal__container--row">
            <div class="row__label">
              <div class="d-inline-block">
                <input
                  type="radio"
                  id="auto"
                  value="auto"
                  v-model="radioIpv4"
                  name="radio-group-method"
                />
                <label for="auto">{{
                  translate("device.config_dashboard.LAN.automatically")
                }}</label>
              </div>
              <div class="d-inline-block">
                <input
                  type="radio"
                  id="manual"
                  value="manual"
                  v-model="radioIpv4"
                  name="radio-group-method"
                />
                <label for="manual">{{
                  translate("device.config_dashboard.LAN.manually")
                }}</label>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="radioIpv4 == 'manual' && radioWanLan == 'wan'"
          class="edit-lan-modal__container--row"
        >
          <div class="row__input" style="max-width: 168px">
            <label class="inp">
              {{ translate("device.config_dashboard.LAN.ip_address") }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca"
                @mouseover="text_assistant.ip_address = true"
                @mouseleave="text_assistant.ip_address = false"
              >
                <span
                  class="hide_text ip_address_wan"
                  :class="{ active: text_assistant.ip_address }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <input
                type="text"
                class="text"
                v-model="data.local_ip"
                :class="{
                  invalid:
                    ($v.data.local_ip.$dirty && !$v.data.local_ip.required)
                }"
              />
              <small
                class="red-text-12"
                style="font-weight: bold"
                v-if="$v.data.local_ip.$dirty && !$v.data.local_ip.required"
                >{{ translate("device.config_dashboard.empty_input") }}</small
              >
              <!-- <small
                class="red-text-12"
                style="bottom: -34px"
                v-if="$v.data.local_ip.$dirty && !$v.data.local_ip.ipAddress"
                >{{ translate("device.config_dashboard.ip_address") }}</small
              > -->
            </label>
          </div>
          <div class="row__input" style="max-width: 168px">
            <label class="inp">
              {{ translate("device.config_dashboard.LAN.mask") }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca"
                @mouseover="text_assistant.mask = true"
                @mouseleave="text_assistant.mask = false"
              >
                <span
                  class="hide_text mask_wan"
                  :class="{ active: text_assistant.mask }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->

              <input
                type="text"
                class="text"
                v-model="data.mask"
                :class="{
                  invalid: ($v.data.mask.$dirty && !$v.data.mask.required)
                }"
              />
              <small
                class="red-text-12"
                style="font-weight: bold"
                v-if="$v.data.mask.$dirty && !$v.data.mask.required"
                >{{ translate("device.config_dashboard.empty_input") }}
              </small>
              <!-- <small
                  class="red-text-12"
                  style="font-weight: bold"
                  v-if="$v.data.mask.$dirty && !$v.data.mask.ipAddress"
                  >{{ translate("device.config_dashboard.ip_address") }}
              </small> -->
            </label>
          </div>
          <div class="row__input" style="max-width: 168px">
            <label class="inp">
              {{ translate("device.config_dashboard.LAN.gateway") }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca"
                @mouseover="text_assistant.gateway_wan = true"
                @mouseleave="text_assistant.gateway_wan = false"
              >
                <span
                  class="hide_text gateway_wan"
                  :class="{ active: text_assistant.gateway_wan }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->

              <input
                type="text"
                class="text"
                v-model="data.gateway"
                :class="{
                  invalid: $v.data.gateway.$dirty && !$v.data.gateway.required,
                }"
              />
              <small
                class="red-text-12"
                style="font-weight: bold"
                v-if="$v.data.gateway.$dirty && !$v.data.gateway.required"
                >{{ translate("device.config_dashboard.empty_input") }}</small
              >
            </label>
          </div>
        </div>

        <div v-if="radioWanLan == 'lan'">
          <div class="edit-lan-modal__container--row">
            <div class="row__input">
              <label class="inp">
                {{ translate("device.config_dashboard.LAN.ip_address") }}
                <!-- <span
                  class="mdi mdi-help-circle-outline"
                  style="font-size: 18px; color: #c3c7ca; position: relative"
                  @mouseover="text_assistant.ip_address = true"
                  @mouseleave="text_assistant.ip_address = false"
                >
                  <span
                    class="hide_text ip_address"
                    :class="{ active: text_assistant.ip_address }"
                  >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </span>
                </span> -->
                <input
                  type="text"
                  class="text"
                  v-model="data.local_ip"
                  :class="{
                    invalid:
                      ($v.data.local_ip.$dirty && !$v.data.local_ip.required)
                  }"
                />
                <small
                  class="red-text-12"
                  style="font-weight: bold"
                  v-if="$v.data.local_ip.$dirty && !$v.data.local_ip.required"
                  >{{ translate("device.config_dashboard.empty_input") }}</small
                >
                <!-- <small
                  class="red-text-12"
                  v-if="$v.data.local_ip.$dirty && !$v.data.local_ip.ipAddress"
                  >{{ translate("device.config_dashboard.ip_address") }}</small
                > -->
              </label>
            </div>
            <div class="row__input">
              <label class="inp">
                {{ translate("device.config_dashboard.LAN.mask") }}
                <!-- <span
                  class="mdi mdi-help-circle-outline"
                  style="font-size: 18px; color: #c3c7ca; position: relative"
                  @mouseover="text_assistant.mask = true"
                  @mouseleave="text_assistant.mask = false"
                >
                  <span
                    class="hide_text mask_lan"
                    :class="{ active: text_assistant.mask }"
                  >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </span>
                </span> -->
                <input
                  type="text"
                  class="text"
                  v-model="data.mask"
                  :class="{
                    invalid: ($v.data.mask.$dirty && !$v.data.mask.required)
                  }"
                />
                <small
                  class="red-text-12"
                  style="font-weight: bold"
                  v-if="$v.data.mask.$dirty && !$v.data.mask.required"
                  >{{ translate("device.config_dashboard.empty_input") }}
                </small>
                <!-- <small
                  class="red-text-12"
                  style="font-weight: bold"
                  v-if="$v.data.mask.$dirty && !$v.data.mask.ipAddress"
                  >{{ translate("device.config_dashboard.ip_address") }}
                </small> -->
              </label>
            </div>
          </div>

          <div class="edit-lan-modal__container--row">
            <div class="row__input">
              <label>
                WAN
                <!-- <span
                  class="mdi mdi-help-circle-outline"
                  style="font-size: 18px; color: #c3c7ca; position: relative"
                  @mouseover="text_assistant.wan = true"
                  @mouseleave="text_assistant.wan = false"
                >
                  <span
                    class="hide_text wan"
                    :class="{ active: text_assistant.wan }"
                  >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </span>
                </span> -->
              </label>
              <multiselect
                class="multiselect_test"
                v-model="data.wan"
                :options="optionsLanWan"
                :multiple="false"
                :clear-on-select="false"
                :placeholder="''"
                :selectLabel="''"
                :selectedLabel="''"
                :deselectLabel="''"
              />
            </div>
          </div>

          <div class="edit-wan-modal__container--row">
            <label class="switch">
              {{ translate("device.config_dashboard.LAN.dhcp_server") }}
              <!-- <span
                class="mdi mdi-help-circle-outline"
                style="font-size: 18px; color: #c3c7ca; position: relative"
                @mouseover="text_assistant.dhcp = true"
                @mouseleave="text_assistant.dhcp = false"
              >
                <span
                  class="hide_text dhcp"
                  :class="{ active: text_assistant.dhcp }"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
              </span> -->
              <input type="checkbox" v-model="isDhcpServerOn" />
              <span class="slider round"></span>
            </label>
          </div>

          <div
            v-if="isDhcpServerOn == true"
            class="edit-lan-modal__container--row"
          >
            <div class="row__input">
              <label for="startIp" class="inp">
                {{ translate("device.config_dashboard.LAN.start_ip_address") }}
                <!-- <span
                  class="mdi mdi-help-circle-outline"
                  style="font-size: 18px; color: #c3c7ca; position: relative"
                  @mouseover="text_assistant.start_ip_address = true"
                  @mouseleave="text_assistant.start_ip_address = false"
                >
                  <span
                    class="hide_text start_ip_address"
                    :class="{ active: text_assistant.start_ip_address }"
                  >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </span>
                </span> -->
                <input
                  type="text"
                  class="text"
                  id="startIp"
                  v-model="data.dhcp.dhcp_start"
                  required
                />
              </label>
            </div>
            <div class="row__input">
              <label for="dns" class="inp">
                {{ translate("device.config_dashboard.LAN.end_ip_address") }}
                <!-- <span
                  class="mdi mdi-help-circle-outline"
                  style="font-size: 18px; color: #c3c7ca; position: relative"
                  @mouseover="text_assistant.ip_address_dhcp = true"
                  @mouseleave="text_assistant.ip_address_dhcp = false"
                >
                  <span
                    class="hide_text ip_address_dhcp"
                    :class="{ active: text_assistant.ip_address_dhcp }"
                  >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </span>
                </span> -->
                <input
                  type="text"
                  class="text"
                  id="dns"
                  v-model="data.dhcp.dhcp_end"
                  required
                />
              </label>
            </div>
          </div>

          <div
            v-if="isDhcpServerOn == true"
            class="edit-lan-modal__container--row"
          >
            <div class="row__input">
              <label for="endIp" class="inp">
                {{ translate("device.config_dashboard.LAN.dns_server") }}
                <!-- <span
                  class="mdi mdi-help-circle-outline"
                  style="font-size: 18px; color: #c3c7ca; position: relative"
                  @mouseover="text_assistant.dns = true"
                  @mouseleave="text_assistant.dns = false"
                >
                  <span
                    class="hide_text dns"
                    :class="{ active: text_assistant.dns }"
                  >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </span>
                </span> -->
                <input
                  type="text"
                  class="text"
                  id="endIp"
                  v-model="data.dhcp.dns"
                  required
                />
              </label>
            </div>
            <div class="row__input">
              <label for="gateway" class="inp">
                {{ translate("device.config_dashboard.LAN.gateway") }}
                <!-- <span
                  class="mdi mdi-help-circle-outline"
                  style="font-size: 18px; color: #c3c7ca; position: relative"
                  @mouseover="text_assistant.gateway_dhcp = true"
                  @mouseleave="text_assistant.gateway_dhcp = false"
                >
                  <span
                    class="hide_text gateway_dhcp"
                    :class="{ active: text_assistant.gateway_dhcp }"
                  >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua.
                  </span>
                </span> -->
                <input
                  v-model="data.dhcp.gateway"
                  type="text"
                  class="text"
                  id="gateway"
                  required
                />
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="edit-lan-modal__buttons">
        <span>
          <span @click="deleteLan" class="btn btn-danger">
            {{ translate("btn.delete") }}
          </span>
        </span>
        <span>
          <span
            @click="close"
            style="margin-right: 10px"
            class="notice-btn btn-success btn btn-info"
          >
            {{ translate("btn.cancel") }}
          </span>
          <span @click="save" class="btn btn-success">
            {{ translate("btn.edit") }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Multiselect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import { ipAddress, required, requiredIf } from "vuelidate/lib/validators";

export default Vue.extend({
  components: {
    Multiselect,
  },
  name: "LanModal",
  mixins: [validationMixin],
  props: {
    dataLan: Object,
    optionsWAN: Array,
    header: String,
    listWanTunnels: Array,
    //selectedLanWanInterfaces: Array,
    optionsPorts: Array,
  },
  data: function () {
    return {
      data: {},
      new_header: "",
      newData: {},
      ifaces: [],
      newOptionsPorts: [],
      radioWanLan: "lan",
      radioIpv4: "manual",
      isMacOn: false,
      isDhcpServerOn: false,
      options: [{}],
      lanPorts: [],
      optionsLanWan: [],
      text_assistant: {
        mac_address: false,
        enter_mac: false,
        interface: false,
        ports: false,
        mode: false,
        ip_address_wan: false,
        ip_address_dhcp: false,
        ip_address: false,
        mask: false,
        wan: false,
        wan_interfaces: false,
        method_ipv4: false,
        dhcp: false,
        start_ip_address: false,
        dns: false,
        gateway_wan: false,
        gateway_dhcp: false,
      },
    };
  },
  validations() {
    return {
      data: {
        local_ip: {
          required: requiredIf(function () {
            return (
              this.radioWanLan == "lan" ||
              (this.radioWanLan == "wan" && this.radioIpv4 == "manual")
            );
          }),
          //ipAddress,
        },
        mask: {
          required: requiredIf(function () {
            return (
              this.radioWanLan == "lan" ||
              (this.radioWanLan == "wan" && this.radioIpv4 == "manual")
            );
          }),
          //ipAddress,
        },
        gateway: {
          required: requiredIf(function () {
            return this.radioWanLan == "wan" && this.radioIpv4 == "manual";
          }),
        },
      },
      lanPorts: {
        required,
      },
      new_header: {
        required
      }
    };
  },
  methods: {
    save() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      } else {
        for (let iface of this.lanPorts) {
          this.ifaces.push(iface.name)
        }
        if (this.radioWanLan == "lan") {
          this.newData[this.new_header] = {
            old_name: this.header,
            mac: this.data.mac,
            iface: this.ifaces,
            local_ip: this.data.local_ip,
            mask: this.data.mask,
            wan: this.data.wan,
            type: this.data.type,
            //dhcp_server_enable: this.dataLan.dhcp_server_enable,
            dhcp: {
              end: this.data.dhcp.dhcp_end || "",
              start: this.data.dhcp.dhcp_start,
              dns: this.data.dhcp.dns || "",
              gateway: this.data.dhcp.gateway || "",
              //local_domain: this.data.dhcp.local_domain || ""
            },
          };
        } else if (this.radioWanLan == "wan" && this.radioIpv4 == "manual") {
          this.newData[this.new_header] = {
            old_name: this.header,
            mac: this.data.mac,
            iface: this.ifaces,
            lan_wan: this.data.lan_wan,
            local_ip: this.data.local_ip,
            mask: this.data.mask,
            gateway: this.data.gateway,
            type: this.data.type,
          }
        } else if (this.radioWanLan == "wan" && this.radioIpv4 == "auto") { 
          this.newData[this.new_header] = {
            old_name: this.header,
            mac: this.data.mac,
            iface: this.ifaces,
            lan_wan: this.data.lan_wan,
            type: this.data.type,
          }
        }
        if (this.isDhcpServerOn == false) {
          delete this.newData[this.new_header].dhcp;
        }
        if (this.isMacOn == false) {
          delete this.newData[this.new_header].mac;
        }
        this.$emit("update", this.newData);
        this.$emit("close");
      }
    },
    deleteLan() {
      this.$emit("delete", this.new_header);
      this.close();
    },
    search_double_dot(string) {
      let count_dotter = string.indexOf("..");
      let name = string.substring(0, count_dotter - 1);
      let number1 = string.substring(count_dotter - 1, count_dotter);
      let number2 = string.substring(count_dotter + 2, count_dotter + 3);
      let array = [];
      for (let i = number1; i <= number2; i++) {
        array.push("" + name + i + "");
      }
      return array;
    },
    close() {
      this.$emit("close");
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
      };
      this.options.push(tag);
      this.lanPorts.push(tag);
    },

    changeLanPorts() {
      if (this.data.iface.indexOf("..") > -1) {
        this.data.iface = this.search_double_dot(this.data.iface);
      } else if (this.data.iface.indexOf(",") > -1) {
        this.data.iface = this.data.iface.split(",");
      }
      if (typeof this.data.iface == "object" && this.data.iface != "") {
        for (let i in this.data.iface) {
          this.lanPorts.push({
            name: this.data.iface[i],
          });
        }
      } else if (this.data.iface != "") {
        this.lanPorts.push({
          name: this.data.iface,
        });
      }
    },
    modalSettings() {
      if (this.data.mac !== "") {
        this.isMacOn = true;
      }
      if (this.data.gateway) {
        this.radioWanLan = "wan";
        this.radioIpv4 = "manual";
      }
      if (this.data.local_ip == "auto" || this.data.local_ip == "dhcp") {
        this.radioWanLan = "wan";
        this.radioIpv4 = "auto";
      }
      if (this.data.dhcp_server == true) {
        this.isDhcpServerOn = true;
      } else if (this.data.dhcp_server == false) {
        this.isDhcpServerOn = false;
      }
    },
  },
  created() {
    this.new_header = this.header;
    //console.log(this.dataLan)
    this.data = {
      iface: this.dataLan.iface ? this.dataLan.iface : "",
      local_ip: this.dataLan.local_ip || "",
      type: this.dataLan.type || "",
      wan: this.dataLan.wan || "",
      gateway: this.dataLan.gateway || "",
      mask: this.dataLan.mask || "",
      mac: this.dataLan.mac || "",
      lan_wan: this.dataLan.lan_wan || "",
      dhcp_server: this.dataLan.dhcp_server_enable || false,
      dhcp: {
        dhcp_end: this.dataLan.dhcp.dhcp_end || this.dataLan.dhcp.end || "",
        dhcp_start: this.dataLan.dhcp.dhcp_start || this.dataLan.dhcp.start || "",
        dns: this.dataLan.dhcp.dns || "",
        gateway: this.dataLan.dhcp.gateway || "",
        //local_domain: this.dataLan.dhcp.local_domain || "",
      },
    }
    this.modalSettings();
    this.changeLanPorts();
    for (let i in this.optionsPorts) {
      this.newOptionsPorts.push({
        name: this.optionsPorts[i],
      });
    }
    this.optionsLanWan = this.optionsWAN
      .concat(this.listWanTunnels)
      .filter((elem) => {
        return elem != this.new_header;
      });
    //this.selectedLanWan = this.selectedLanWanInterfaces;
  },
});
</script>

<style src="assets/sass/radio-button.scss" lang="scss" scoped></style>
<style src="assets/sass/slider-round.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.edit-lan-modal {
  max-width: 600px;
  padding: 0;

  &__header {
    //color: white;
    font-size: 18px;
    padding: 26px 24px;
    border-bottom: 1px solid #cecfd1;
    display: flex;
    justify-content: space-between;
  }

  &__container {
    padding: 8px 24px;
    max-height: 600px;
    overflow-y: scroll;
    overflow-x: hidden;
    &--row {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin: 20px 0;

      // .hide_text{
      //   width: 300px;
      //   position: absolute;
      //   bottom: -43px;
      //   left: 85px;
      //   z-index: 2;
      //   white-space: normal;
      //   background: #f9f9f9;
      //   padding: 10px;
      //   border-radius: 5px;
      //   transition: 0.2s;
      //   box-shadow: 1px 1px 5px #202020;
      //   opacity: 0;

      //   &.active{
      //       opacity: 1;
      //       z-index: 1;
      //       transform: translate(0,0);
      //     }
      // }

      label {
        margin-bottom: 0;
      }
      .row__label {
        color: gray;
        font-size: 13px;
        display: flex;
        margin-right: 24px;
      }
      .row__input {
        max-width: 268px;
        width: 100%;
        position: relative;

        label {
          width: 100%;
        }
        span {
          color: #c3c7ca;
          font-size: 13px;
          font-weight: bold;
        }
        input {
          width: 100%;
          border: none;
          outline: none;
          padding: 0;
          height: 33px;
          font-size: 14px;
          font-weight: 400;
          background: none;
          border-radius: 0;
          //color: #c3c7ca!important;
          color: #66615b;
          transition: all 0.4s ease;
          border-bottom: 1px solid #515459;
          background-color: transparent !important;
          font-family: Roboto, sans-serif;
          caret-color: #c3c7ca;
        }
        /* .invalid{
            border-bottom: 1px solid #eb5757;
        } */
      }
    }
    &--line {
      border-bottom: 1px solid #cecfd1;
      margin: 5px 0;
    }
  }

  &__buttons {
    border-top: 1px solid #cecfd1;
    padding: 24px;
    display: flex;
    justify-content: space-between;
  }

  &__containerSettings {
    color: white;
    background: white;
    border-radius: 2px;
    max-width: 380px;
    width: 100%;
    margin-right: 24px;
    margin-bottom: 10px;
  }
}

.vs__selected .vs__deselect svg {
  width: 15px;
  height: 15px;
  margin: 4px -5px 0 5px;
}

.vue-select {
  .vs__dropdown-toggle {
    border: none !important;
    border-bottom: 1px solid #515459 !important;
    color: #c3c7ca;
    background: none;
  }
  input {
    //color: #c3c7ca;
    color: #66615b;
    padding: 0;
  }
}

.hide_text {
  width: 300px;
  position: absolute;
  bottom: -43px;
  left: 85px;
  white-space: normal;
  background: #f9f9f9;
  padding: 10px;
  border-radius: 5px;
  transition: 0.2s;
  box-shadow: 1px 1px 5px #202020;
  opacity: 0;
  z-index: -1;
  /* &.name {
    bottom: -40px;
    left: 55px;
  } */
  &.mac_address {
    bottom: -40px;
    left: -208px;
    //transform: translateX(200px);
  }
  &.interface {
    bottom: -40px;
    left: 72px;
    //transform: translateX(-200px);
  }
  &.ports {
    bottom: -32px;
    left: 49px;
    //transform: translateX(-200px);
  }
  &.mode {
    bottom: 22px;
    left: 14px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
    position: absolute;
    //transform: translateX(-200px);
  }
  &.wan_interfaces {
    bottom: -32px;
    left: 113px;
    //transform: translateX(-200px);
  }
  &.method_ipv4 {
    bottom: 22px;
    left: 14px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
    position: absolute;
    //transform: translateX(-200px);
  }
  &.ip_address_wan {
    bottom: 57px;
    left: 83px;
  }
  &.mask_wan {
    bottom: 57px;
    left: 52px;
  }
  &.gateway_wan {
    bottom: 58px;
    left: -236px;
  }
  &.ip_address {
    bottom: 22px;
    left: 10px;
  }
  &.ip_address_dhcp {
    bottom: 22px;
    left: -293px;
  }
  &.mask_lan {
    bottom: 22px;
    left: -291px;
  }
  &.wan {
    bottom: 22px;
    left: 11px;
  }
  &.dhcp {
    bottom: 22px;
    left: 11px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
    position: absolute;
  }
  &.start_ip_address {
    bottom: 22px;
    left: 11px;
  }
  &.dns {
    bottom: 22px;
    left: 11px;
  }
  &.gateway_dhcp {
    bottom: 22px;
    left: -293px;
  }
  &.enter_mac {
    bottom: -66px;
    left: 11px;
    color: #c3c7ca;
    font-size: 13px;
    font-weight: bold;
  }
  &.active {
    opacity: 1;
    z-index: 1;
    transform: translate(0, 0);
  }
}
</style>